<template>
  <el-card shadow="never" class="advert-list-panel">
    <div slot="header" class="clearfix">
      <span>{{ $t("advert-config.AdvertListPanel.140638-0") }}</span>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        style="float: right"
        @click="$emit('add-advert')"
        v-hasPerm="['adverts:insert']"
      >
        {{ $t("advert-config.AdvertListPanel.140638-23") }}
      </el-button>
    </div>

    <div class="filter-bar">
      <el-input
        :value="searchKeyword"
        @input="$emit('update:searchKeyword', $event)"
        :placeholder="$t('advert-config.AdvertListPanel.140638-1')"
        prefix-icon="el-icon-search"
        clearable
        @keyup.enter.native="$emit('search')"
        style="flex: 1"
        size="small"
      >
        <el-select
          slot="prepend"
          :value="filterType"
          @input="$emit('update:filterType', $event)"
          :placeholder="$t('advert-config.AdvertListPanel.140638-2')"
          clearable
          style="width: 140px"
          size="small"
          @change="$emit('search')"
        >
          <el-option :label="$t('advert-config.AdvertListPanel.140638-3')" value=""></el-option>
          <el-option :label="$t('advert-config.AdvertListPanel.140638-4')" value="0"></el-option>
          <el-option :label="$t('advert-config.AdvertListPanel.140638-5')" value="1"></el-option>
          <!-- <el-option :label="$t('advert-config.AdvertListPanel.140638-6')" value="2"></el-option> -->
          <el-option :label="$t('advert-config.AdvertListPanel.140638-7')" value="2"></el-option>
        </el-select>
      </el-input>

      <div class="filter-actions">
        <el-button type="primary" icon="el-icon-search" size="small" @click="$emit('search')">{{
          $t("advert-config.AdvertListPanel.140638-8")
        }}</el-button>
        <el-button icon="el-icon-refresh-left" size="small" @click="$emit('reset')">{{
          $t("advert-config.AdvertListPanel.140638-9")
        }}</el-button>
      </div>
    </div>

    <div class="advert-list" v-loading="loading">
      <div v-if="advertList.length > 0" class="list-wrapper">
        <div
          v-for="advert in advertList"
          :key="advert.id"
          class="advert-card"
          :class="{
            'is-selected': isAdvertSelected(advert.id),
            'is-disabled': !canAddToCurrentSlot(advert) && !isAdvertSelected(advert.id)
          }"
        >
          <div class="card-preview">
            <el-image
              v-if="advert.type === 0 || advert.type === '0'"
              :src="advert.url"
              :preview-src-list="[advert.url]"
              fit="cover"
              class="preview-image"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div v-else-if="advert.type === 1 || advert.type === '1'" class="preview-video-wrapper">
              <video-player
                class="video-player-box vjs-custom-skin"
                :ref="'videoPlayer-' + advert.id"
                :options="getVideoPlayerOptions(advert)"
                :playsinline="true"
              />
            </div>
            <div v-else class="preview-other">
              <i class="el-icon-link"></i>
              <span>{{ advert.type == 2 ? $t("advert-config.AdvertListPanel.140638-10") : "3D" }}</span>
            </div>

            <div
              v-if="isAdvertSelected(advert.id)"
              class="selected-badge"
              @click.stop="handleCancelSelected(advert.id)"
            >
              <i class="el-icon-check"></i>
            </div>
          </div>

          <div class="card-info">
            <div class="card-title" :title="advert.head">
              {{ advert.head || $t("advert-config.AdvertListPanel.140638-11") }}
            </div>
            <div>
              <span class="card-type">{{ getAdvertTypeName(advert.type) }}</span>
            </div>
            <div>
              <el-tag v-if="getAdvertUsageInAllTabs(advert.id).length > 0" size="mini" type="success" effect="plain">
                {{ $t("advert-config.AdvertListPanel.140638-12") }} {{ getAdvertUsageInAllTabs(advert.id).join("、") }}
              </el-tag>
              <el-tag v-else size="mini" type="warning" effect="plain">
                {{ $t("advert-config.AdvertListPanel.140638-13") }}
              </el-tag>
            </div>
          </div>

          <div class="card-actions">
            <el-button
              v-if="isAdvertSelected(advert.id)"
              type="danger"
              size="mini"
              plain
              @click.stop="handleCancelSelected(advert.id)"
            >
              {{ $t("advertGroupRela.remove") }}
            </el-button>
            <el-tooltip
              v-else-if="!canAddToCurrentSlot(advert)"
              :content="$t('advert-config.AdvertListPanel.140638-15')"
              placement="top"
            >
              <el-button type="info" size="mini" disabled plain>
                {{ $t("advert-config.AdvertListPanel.140638-16") }}
              </el-button>
            </el-tooltip>
            <el-button v-else type="primary" size="mini" icon="el-icon-plus" @click="$emit('add', advert)">
              {{ $t("advert-config.AdvertListPanel.140638-17") }}
            </el-button>
          </div>
        </div>
      </div>
      <el-empty v-else :description="$t('advert-config.AdvertListPanel.140638-18')"></el-empty>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :current-page="page.pageIndex"
        :page-sizes="[12, 24, 36, 48]"
        :page-size="page.pageSize"
        :total="page.total"
        @size-change="$emit('size-change', $event)"
        @current-change="$emit('page-change', $event)"
      />
    </div>

    <el-dialog
      :visible.sync="videoPreviewVisible"
      :title="videoPreviewTitle"
      width="70%"
      top="8vh"
      append-to-body
      destroy-on-close
      @close="closeVideoPreview"
    >
      <video v-if="videoPreviewUrl" :src="videoPreviewUrl" controls autoplay class="preview-video-player"></video>
    </el-dialog>
  </el-card>
</template>

<script>
  import "video.js/dist/video-js.css";
  import { videoPlayer } from "vue-video-player";

  export default {
    name: "AdvertListPanel",
    components: {
      videoPlayer
    },
    data() {
      return {
        videoPreviewVisible: false,
        videoPreviewUrl: "",
        videoPreviewTitle: ""
      };
    },
    props: {
      advertList: {
        type: Array,
        default: () => []
      },
      page: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      searchKeyword: {
        type: String,
        default: ""
      },
      filterType: {
        type: String,
        default: ""
      },
      currentTabAdverts: {
        type: Array,
        default: () => []
      },
      allAdverts: {
        type: Object,
        required: true
      }
    },
    methods: {
      getVideoPlayerOptions(advert) {
        return {
          autoplay: false,
          muted: true,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          fluid: false,
          width: "100%",
          height: "100%",
          sources: [
            {
              type: "video/mp4",
              src: advert.url
            }
          ],
          poster: advert.url + "?x-oss-process=video/snapshot,t_1000,m_fast"
        };
      },
      isAdvertSelected(advertId) {
        return this.currentTabAdverts.some(item => item.id === advertId);
      },
      canAddToCurrentSlot(advert) {
        if (this.currentTabAdverts.length === 0) {
          return true;
        }
        const firstAdvertType = String(this.currentTabAdverts[0].type);
        const currentAdvertType = String(advert.type);
        return firstAdvertType === currentAdvertType;
      },
      getAdvertUsageInAllTabs(advertId) {
        const usage = [];
        const tabNames = {
          screenSaver: this.$t("advert-config.AdvertListPanel.140638-19"),
          topBanner: this.$t("advert-config.AdvertListPanel.140638-20"),
          externalScreen: this.$t("advert-config.AdvertListPanel.140638-21")
        };

        if (this.allAdverts.screenSaver && this.allAdverts.screenSaver.some(item => item.id === advertId)) {
          usage.push(tabNames.screenSaver);
        }
        if (this.allAdverts.topBanner && this.allAdverts.topBanner.some(item => item.id === advertId)) {
          usage.push(tabNames.topBanner);
        }
        if (this.allAdverts.externalScreen && this.allAdverts.externalScreen.some(item => item.id === advertId)) {
          usage.push(tabNames.externalScreen);
        }

        return usage;
      },
      getAdvertTypeName(type) {
        const typeMap = {
          0: this.$t("advert-config.AdvertListPanel.140638-4"),
          1: this.$t("advert-config.AdvertListPanel.140638-5"),
          // 2: this.$t("advert-config.AdvertListPanel.140638-6"),
          2: this.$t("advert-config.AdvertListPanel.140638-7")
        };
        return typeMap[String(type)] || this.$t("advert-config.AdvertListPanel.140638-22");
      },
      previewVideo(videoUrl) {
        if (!videoUrl) {
          return;
        }
        this.videoPreviewUrl = videoUrl;
        this.videoPreviewTitle = this.$t("advert-config.AdvertListPanel.140638-5");
        this.videoPreviewVisible = true;
      },
      closeVideoPreview() {
        this.videoPreviewVisible = false;
        this.videoPreviewUrl = "";
        this.videoPreviewTitle = "";
      },
      handleCancelSelected(advertId) {
        this.$emit("remove-selected", advertId);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .advert-list-panel {
    height: 100%;
    display: flex;
    flex-direction: column;

    ::v-deep .el-card__header {
      background: #f5f7fa;
      font-weight: 500;
    }

    ::v-deep .el-card__body {
      padding: 15px;
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
    }
  }

  .filter-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
  }

  .filter-actions {
    display: flex;
    gap: 10px;
  }

  @media (max-width: 1440px) {
    .advert-list {
      .list-wrapper {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 12px;
      }
    }
  }

  @media (max-width: 1280px) {
    .filter-bar {
      align-items: stretch;

      > .el-input,
      > .el-select,
      > .filter-actions {
        width: 100% !important;
      }
    }

    .filter-actions {
      .el-button {
        flex: 1;
      }
    }
  }

  .advert-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 15px;

    .list-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 15px;
    }
  }

  .advert-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      border-color: #409eff;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
    }

    &.is-selected {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        border-color: #ebeef5;
        box-shadow: none;
      }
    }

    .card-preview {
      position: relative;
      height: 140px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .preview-image {
        width: 100%;
        height: 100%;
        cursor: pointer;
        object-fit: cover;

        ::v-deep .image-slot {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
      }

      .preview-video-wrapper {
        width: 100%;
        height: 100%;

        .video-player-box {
          width: 100%;
          height: 100%;

          ::v-deep .video-js {
            width: 100% !important;
            height: 100% !important;

            .vjs-tech {
              width: 100% !important;
              height: 100% !important;
              object-fit: contain;
            }

            .vjs-big-play-button {
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }

            .vjs-control-bar {
              width: 100%;
            }
          }
        }
      }

      .preview-video,
      .preview-other,
      .image-slot {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        i {
          font-size: 48px;
        }
      }

      .preview-video,
      .preview-other {
        color: #909399;
      }

      .image-slot {
        color: #c0c4cc;
      }

      .selected-badge {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 24px;
        height: 24px;
        background: #409eff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;

        &:hover {
          background: #66b1ff;
        }
      }
    }

    .card-info {
      padding: 10px;

      .card-title {
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-type {
        font-size: 12px;
        color: #909399;
      }
    }

    .card-actions {
      padding: 0 10px 10px;

      .el-button {
        width: 100%;
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
    padding-top: 15px;
    margin-top: 15px;
    border-top: 1px solid #ebeef5;
  }

  .preview-video-player {
    width: 100%;
    max-height: 70vh;
    background: #000;
  }
</style>
